export default "__VITE_ASSET__940e391e__"